import { useNavigate } from "react-router-dom";

export const TVShowListCard = ({ tvShowList }) => {
  const navigate = useNavigate();
  const handleClick = () =>
    navigate(`/tvshows/${tvShowList.sid}`, { state: { tvShowList } });

  return (
    <li
      onClick={handleClick}
      className="card p-4 cursor-pointer hover:border-teal-600 flex items-center justify-between"
    >
      <span className="font-medium text-stone-800">{tvShowList?.name}</span>
      <span className="text-sm text-stone-500">{tvShowList?.type}</span>
    </li>
  );
};

const TVShowListRow = ({ tvShowList }) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/tvshows/${tvShowList.sid}`, { state: { tvShowList } });
  };
  return (
    <tr onClick={handleRowClick} className="cursor-pointer hover:bg-stone-100">
      <td className="px-3 py-2">{tvShowList?.name}</td>
      <td className="px-3 py-2">{tvShowList?.type}</td>
    </tr>
  );
};

export default TVShowListRow;
